import type { WritableAtom } from 'jotai';
import { atom } from 'jotai';

import {
  APP_SIDEBAR_OPEN,
  MOBILE_BREAKPOINT,
  SIDEBAR_DEFAULT_WIDTH,
} from './constants';

export const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

const _appSidebarOpenAtom = atom(!isMobile && !environment.isBrowser);

type SetOpenArg = boolean | ((prev: boolean) => boolean);
export const appSidebarOpenAtom: WritableAtom<boolean, [SetOpenArg], void> =
  atom(
    get => get(_appSidebarOpenAtom),
    (get, set, value: SetOpenArg) => {
      const newValue =
        typeof value === 'function' ? value(get(_appSidebarOpenAtom)) : value;
      set(_appSidebarOpenAtom, newValue);
    }
  );
export const appSidebarFloatingAtom = atom(isMobile);
export const isMobileView = atom(isMobile); // redefining because its hard to figure out this is what this atom means

export const appSidebarResizingAtom = atom(false);
export const appSidebarWidthAtom = atom(SIDEBAR_DEFAULT_WIDTH);

export { APP_SIDEBAR_OPEN, MOBILE_BREAKPOINT, SIDEBAR_DEFAULT_WIDTH };
